import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../../resources/i18n/I18n'

const ModalEstateCreation = ({ showModal, toggleModal, createLabel, title, error }) => {
  const [label, setLabel] = useState('')
  const [code, setCode] = useState('')
  const [errorLabel, setErrorLabel] = useState(false)
  const [errorCode, setErrorCode] = useState(false)

  useEffect(() => {
    if (error) {
      setErrorCode(error)
    }
  }, [error])

  const handleCreateLabel = async () => {
    let hasError = false

    if (!code) {
      setErrorCode(I18n.t('Required'))
      hasError = true
    }
    if (!label) {
      setErrorLabel(I18n.t('Required'))
      hasError = true
    }

    if (!hasError) {
      setErrorCode(false)
      setErrorLabel(false)
      const result = await createLabel(label, code)
      if (result && result.description && result.description.message) {
        setErrorCode(result.description.message)
      } else {
        handleCloseModal()
      }
    }
  }

  const handleCloseModal = () => {
    setErrorCode(false)
    setErrorLabel(false)
    setLabel('')
    setCode('')
    toggleModal()
  }

  return (
    <Modal show={showModal} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title || I18n.t('CreateConfirmTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>{I18n.t('Label')}</Form.Label>
          <Form.Control value={label} onChange={(e) => setLabel(e.target.value)} />
          {errorLabel && <Form.Text className="error">{errorLabel}</Form.Text>}
        </Form.Group>
        <Form.Group>
          <Form.Label>{I18n.t('Code')}</Form.Label>
          <Form.Control value={code} onChange={(e) => setCode(e.target.value)} />
          {errorCode && <Form.Text className="error">{errorCode}</Form.Text>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={handleCloseModal}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleCreateLabel}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalEstateCreation
